export default __webpack_public_path__ + "static/media/orden-venta-descargar.05a19787.svg";